const main = () => {
    if (document.querySelector('.c-others-select-search') == null) return;

    document.querySelectorAll('.c-others-select-search').forEach((root) => {
        const trigger = root.querySelector('.c-others-select-search__trigger');
        const label = root.querySelector('.c-others-select-search__label');
        const nativeSelect = root.querySelector('.c-others-select-search__native');
        const options = root.querySelectorAll('.c-others-select-search__option');
        let focusedIndex = -1;

        const setFocusedIndex = (index) => {
            focusedIndex = index;
            options.forEach((o, i) => {
                if (i === index) {
                    o.setAttribute('data-focused', '');
                    o.scrollIntoView({ block: 'nearest' });
                } else {
                    o.removeAttribute('data-focused');
                }
            });
        };

        const selectOption = (option) => {
            const value = option.getAttribute('data-value');
            const text = option.querySelector('.c-others-select-search__option-text').textContent;

            // ラベル更新
            label.textContent = text;

            // 選択状態の更新
            options.forEach((o) => o.removeAttribute('data-selected'));
            option.setAttribute('data-selected', '');

            // hidden selectの値を更新してchangeイベントを発火
            nativeSelect.value = value;
            nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));

            // ドロップダウンを閉じる
            root.removeAttribute('data-open');
            trigger.focus();
        };

        const openDropdown = () => {
            // 他のセレクトを閉じる
            document.querySelectorAll('.c-others-select-search[data-open]').forEach((el) => {
                if (el !== root) el.removeAttribute('data-open');
            });
            root.setAttribute('data-open', '');
            // 選択済みの項目にフォーカスを合わせる
            const selectedIndex = [...options].findIndex((o) => o.hasAttribute('data-selected'));
            setFocusedIndex(selectedIndex >= 0 ? selectedIndex : 0);
        };

        const closeDropdown = () => {
            root.removeAttribute('data-open');
            setFocusedIndex(-1);
        };

        // トリガークリックで開閉
        trigger.addEventListener('click', () => {
            if (root.hasAttribute('data-open')) {
                closeDropdown();
            } else {
                openDropdown();
            }
        });

        // キーボード操作
        root.addEventListener('keydown', (e) => {
            const isOpen = root.hasAttribute('data-open');

            if (!isOpen) {
                // 閉じている状態でEnter/Space/ArrowDown/ArrowUpで開く
                if (['Enter', ' ', 'ArrowDown', 'ArrowUp'].includes(e.key)) {
                    e.preventDefault();
                    openDropdown();
                }
                return;
            }

            switch (e.key) {
                case 'ArrowDown':
                    e.preventDefault();
                    setFocusedIndex(focusedIndex < options.length - 1 ? focusedIndex + 1 : 0);
                    break;
                case 'ArrowUp':
                    e.preventDefault();
                    setFocusedIndex(focusedIndex > 0 ? focusedIndex - 1 : options.length - 1);
                    break;
                case 'Enter':
                case ' ':
                    e.preventDefault();
                    if (focusedIndex >= 0) {
                        selectOption(options[focusedIndex]);
                    }
                    break;
                case 'Escape':
                case 'Tab':
                    closeDropdown();
                    break;
            }
        });

        // オプション選択
        options.forEach((option) => {
            option.addEventListener('click', () => {
                selectOption(option);
            });
        });
    });

    // 外側クリックで閉じる
    document.addEventListener('click', (e) => {
        if (!e.target.closest('.c-others-select-search')) {
            document.querySelectorAll('.c-others-select-search[data-open]').forEach((el) => {
                el.removeAttribute('data-open');
            });
        }
    });
}

export default main;
